import React from 'react';
import '../Layout.css';
import { motion } from 'framer-motion';

export default class siteInformation extends React.Component {
    render() {
        return (
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ delay: 1, ease: "easeInOut", duration:1.05 }}
            >
                <aside className="siteInformationText">
                    <p className="siteName">{this.props.siteName}</p>
                    <p className="siteAuthor">{this.props.siteAuthor}</p>
                </aside>
            </motion.div>
        )
    }
}